import ListEdit from "../UI/ListEdit";
import {Link} from "react-router-dom";
import React, {Fragment, useState} from "react";
import Box from "../UI/Box";
import {
    convertToDisplayDate,
    getMollieTransactionTypeBadge,
    getPaymentMethodLabel,
    getSettlementAmountCell
} from "../../utility/utility";
import {useMollieSettlement} from "../../hooks/useMollieSettlement";
import {useMollieSettlementTransactions} from "../../hooks/useMollieSettlementTransactions";

const MollieSettlementTransactionList = (props) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const {settlement, error} = useMollieSettlement(props.settlementId);
    const {transactions, pagination} = useMollieSettlementTransactions(props.settlementId, page, pageSize, 0);

    const transactionList = transactions.map((transaction) => {
        return {
            transactionId : transaction.transactionId,
            type          : getMollieTransactionTypeBadge(transaction.type),
            gross         : getSettlementAmountCell(transaction.gross, transaction.currency),
            fee           : getSettlementAmountCell(transaction.fee, transaction.currency),
            net           : getSettlementAmountCell(transaction.net, transaction.currency),
            customer      : transaction.customerName,
            invoice       : transaction.invoiceNumber,
            // Same snake_case internal name the Stripe breakdown returns, so it
            // goes through the same label map. Unknown methods Mollie may report
            // (ideal, for one) fall back to their prettified name rather than
            // vanishing, and a chargeback line has no payment method at all.
            paymentMethod : transaction.paymentMethod
                ? getPaymentMethodLabel(transaction.paymentMethod)
                : <span className="text-gray-300">—</span>,
            created       : convertToDisplayDate(transaction.created)
        }
    });

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const listHeaders = [
        'Transaction',
        'Type',
        'Gross',
        'Fee',
        'Net',
        'Customer',
        'Invoice',
        'Payment type',
        'Date'
    ];

    const columns = {
        functionParams : [],
        dataKeys       : [
            'transactionId',
            'type',
            'gross',
            'fee',
            'net',
            'customer',
            'invoice',
            'paymentMethod',
            'created'
        ]
    }

    return (
        <Fragment>
            <Link to={'/payouts?provider=mollie'}>Back</Link>
            <Box>
                {error && (
                    <p className="text-sm text-red-600">
                        This settlement could not be loaded. It may not exist, or it has not been
                        pulled from Mollie yet.
                    </p>
                )}
                {settlement && (
                    <h1 className="text-lg font-semibold text-gray-900">
                        Settlement: {settlement.reference} ({settlement.settlementId})
                    </h1>
                )}
                <ListEdit
                    headers={listHeaders}
                    items={transactionList}
                    columns={columns}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                />
            </Box>
        </Fragment>
    );
}

export default MollieSettlementTransactionList;
